import type { IUserInfo } from '@/interfaces'

export class UserInfo implements IUserInfo {
	displayName: string
	givenName: string
	id: string | number
	jobTitle: string
	mail: string
	mobilePhone: string
	officeLocation: string
	preferredLanguage: string
	surname: string
	userPrincipalName: string
	photo: string

	constructor({
		displayName,
		givenName,
		id,
		jobTitle,
		mail,
		mobilePhone,
		officeLocation,
		preferredLanguage,
		surname,
		userPrincipalName,
		photo
	}: Partial<IUserInfo> = {}) {
		this.displayName = displayName || ''
		this.givenName = givenName || ''
		this.id = id || ''
		this.jobTitle = jobTitle || ''
		this.mail = mail || ''
		this.mobilePhone = mobilePhone || ''
		this.officeLocation = officeLocation || ''
		this.preferredLanguage = preferredLanguage || ''
		this.surname = surname || ''
		this.userPrincipalName = userPrincipalName || ''
		this.photo = photo || ''
	}
}
